<ng-template [ngIf]="html" [ngIfElse]="plainText">
    <span [innerHtml]="getText()"></span>
</ng-template>
<ng-template #plainText>
    <span class="chapter-detail-text">
      {{getText()}}
      
    </span>
    <span class='read-more-btn' *ngIf="trimmed" (click)="showCompleteData()">Read More..</span>
</ng-template>